import {
  SET_MISSIONS,
  SET_MISSION,
  SET_MISSION_LOADING,
  SET_MISSION_META_GROUPS,
  SET_MISSION_IC_NOT_READY,
  PUSH_MISSION_META_GROUPS_DISABLED,
  REMOVE_MISSION_META_GROUPS_DISABLED,
} from './mutation-types';
import MissionsAPI from '~/services/api/MissionsAPI';

export async function fetchMissions({ commit }, { filters, meta }) {
  try {
    commit(SET_MISSION_LOADING, true);
    const missions = await MissionsAPI.fetchMissions(filters, meta);
    commit(SET_MISSIONS, missions);
    return Promise.resolve(missions.data);
  } catch (error) {
    return Promise.reject(error);
  } finally {
    commit(SET_MISSION_LOADING, false);
  }
}

/**
 * Fetch a single Mission
 * @param {function} commit - The vuex commit function
 * @param {string} payload - The mission ID
 */
export async function fetchMission({ commit }, { missionId, noMedia }) {
  try {
    commit(SET_MISSION_LOADING, true);
    const mission = await MissionsAPI.fetchMission(missionId, noMedia);
    const data = mission?.data ?? null;
    commit(SET_MISSION, data);
    // Set the missionId in sessionStorage in case user reloads
    if (data && process.browser) {
      sessionStorage.setItem('missionId', missionId);
    }
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  } finally {
    commit(SET_MISSION_LOADING, false);
  }
}

/**
 * Fetch Mission Meta groups
 * @param {function} commit - The vuex commit function
 * @param {string} missionId - The mission ID
 */
export async function fetchMissionMetaGroups({ commit }, missionId) {
  try {
    const mission = await MissionsAPI.fetchMissionMetaGroups(missionId);
    const data = mission?.data ?? null;
    commit(SET_MISSION_META_GROUPS, data);
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function addMetaGroupsDisabled({ commit }, meta) {
  try {
    if (meta) {
      commit(PUSH_MISSION_META_GROUPS_DISABLED, { meta });
    }
    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function removeMetaGroupsDisabled({ commit, state }, meta) {
  try {
    commit(REMOVE_MISSION_META_GROUPS_DISABLED, { list: state.missionMetaGroupsDisabled, meta });
    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Fetch All Missions
 * @param {function} commit - The vuex commit function
 */
 export async function fetchAllNearMissions({ commit }) {
  try {
    const mission = await MissionsAPI.fetchICNotReadyMissions();
    const data = mission?.data ?? null;
    commit(SET_MISSION_IC_NOT_READY, data);
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}
